import './App.css';
import RoutesConfig from './configs/RoutesConfig';

function App() {
  return (
    <RoutesConfig/>
  );
}

export default App;
